import React from 'react'
import ListComponentProto from './list-multi-proto'


export default function renderListInFormNew(id:string, props:any) {
    return (
        <ListComponentProto
            renderMode="form-new"
            id={id}
            {...props}
        />
    )
}
